/* global axios */
import ApiClient from '../ApiClient';

class WgptBotEvalCriteriaAPI extends ApiClient {
  constructor(botId) {
    super(`bots/${botId}/eval_criteria`, { accountScoped: true, wgpt: true });
  }

  seed() {
    return axios.post(`${this.url}/seed`);
  }
}

export default WgptBotEvalCriteriaAPI;
